import { Fragment, useEffect, useState } from "react";
import Table from "../Components/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  dataDoctorResults,
  dataDoctorResultsGrouped,
  dataResultsDetailed,
} from "../utils/helpers";
import TextContentInfo from "../Components/TextContentInfo";
import useInitialResultsData from "../hooks/useInitialResultsData";
import { changeLoading } from "../slices/userReducer";
import Flatpickr from "../Components/Flatpickr";
import { useHandleViewResult } from "../hooks";
import Modal from "@mui/material/Modal";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import AppHeader from "../Components/navigation/AppHeader";
import {
  GroupedResultsTableMobile,
  PdfViewer,
  TableResults,
} from "../Components";
import axios from "axios";
import DicomViewer from "../Components/DicomViewer";

export default function DoctorResults() {
  const [currentPage, setCurrentPage] = useState(0);
  const [resultsPerPage, setResultsPerPage] = useState(100);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const { config, id, role } = useSelector((state) => state.user);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [examinationData, setExaminationData] = useState([]);
  const isMobile = useMediaQuery("(max-width: 960px)");
  const [errorMessage, setErrorMessage] = useState("");
  const [filterEGN, setFilterEGN] = useState("");
  const [filterName, setFilterName] = useState("");
  const [filterIme, setFilterIme] = useState("");
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [patientInfo, setPatientInfo] = useState(null);
  const [resultsData, setResultsData] = useState([]);
  const [dicomData, setDicomData] = useState([]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const { fetchResultsData, fetchedData } = useInitialResultsData();

  useEffect(() => {
    if (location.state?.data && location.state.data.length > 0) {
      setExaminationData(location.state.data);
    }
  }, [location.state?.data, navigate]);

  useEffect(() => {
    if (fetchedData && fetchedData.length > 0) {
      setExaminationData(fetchedData);
    }
  }, [fetchedData]);

  const handleShowAllResults = async () => {
    if (!dateFrom || !dateTo) return;
    dispatch(changeLoading(true));
    if (id) {
      const newData = await fetchResultsData({
        dateTo,
        dateFrom,
        config,
        filterEGN,
        filterName,
        filterIme,
      });
      setExaminationData(newData || []);
    }
    dispatch(changeLoading(false));
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const handleResultsPerPageChange = (event) => {
    setResultsPerPage(parseInt(event.target.value));
    setCurrentPage(0);
  };
  const [handleViewResultPdf, openModal, handleCloseModal, base64Data, error] =
    useHandleViewResult();

  const handleViewResult = async ([IdEpruvetka, TipRezultat]) => {
    handleViewResultPdf(IdEpruvetka, TipRezultat, fetchedData, token);
  };
  const noResultsFound = examinationData.length === 0;

  const handleCloseModal2 = () => {
    setOpenModal2(false);
    setPatientInfo(null);
    // setResultsData([]);
  };
  const handleCloseModal3 = () => {
    setOpenModal3(false);
  };

  useEffect(() => {
    if (resultsData.length > 0 && patientInfo) {
      // setOpenModal2(true);
      setTimeout(() => setOpenModal2(true), 100);
    }
  }, [resultsData, patientInfo]);

  function safeStringify(obj) {
    // const maxDepth = 3;
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return "[Circular]"; // prevent circular reference
        }
        seen.add(value);
      }

      return value;
    });
  }

  const handleResults = async (IdEpruvetka, patientInfo) => {
    dispatch(changeLoading(true));
    try {
      const requestBody = {
        IdEpruvetka: IdEpruvetka,
      };
      const response = await axios.post(
        `${config.apiBaseUrl}/GLabResultService/GetReferralClinicalResult`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          transformRequest: [(data) => safeStringify(data)],
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        }
      );

      if (response.data) {
        const sanitizedData = JSON.parse(safeStringify(response.data));
        setResultsData(sanitizedData);
        setPatientInfo(patientInfo);
        setOpenModal2(true);
      }
    } catch (error) {
      console.error("Error fetching  results:", error);
    } finally {
      dispatch(changeLoading(false));
    }
  };

  const handleResultsPacs = async (IdEpruvetka) => {
    dispatch(changeLoading(true));
    try {
      const requestBody = {
        IdEpruvetka: IdEpruvetka,
      };
      const response = await axios.post(
        `${config.apiBaseUrl}/GLabService/GetPacsFile`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Raw API response:", response);

      if (response.data) {
        // If the response is a JSON string, parse it
        const parsedData =
          typeof response.data === "string"
            ? JSON.parse(response.data)
            : response.data;

        // console.log("DICOM data:", parsedData);

        if (Array.isArray(parsedData) && parsedData.length > 0) {
          setDicomData(parsedData);
          setOpenModal3(true);
        } else {
          console.warn("No DICOM images found in response");
        }
      }
    } catch (error) {
      console.error("Error fetching DICOM results:", error);
    } finally {
      dispatch(changeLoading(false));
    }
  };

  return (
    <Fragment>
      <TextContentInfo text="Резултати" />
      {errorMessage && <div id="badRequest">{error}</div>}
      <Flatpickr
        dateFrom={dateFrom}
        dateTo={dateTo}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        handleShowAllResults={handleShowAllResults}
        filterEGN={filterEGN}
        setFilterEGN={setFilterEGN}
        filterName={filterName}
        setFilterName={setFilterName}
        filterIme={filterIme}
        setFilterIme={setFilterIme}
        setErrorMessage={setErrorMessage}
      />

      {isMobile ? (
        <GroupedResultsTableMobile
          results={examinationData}
          resultCell={[
            "DateRefferal",
            "Paket",
            "IdentifierPac",
            "GivenPacName",
            "MiddlePacName",
            "FamilyPacName",
          ]}
          currentPage={currentPage}
          resultsPerPage={resultsPerPage}
          handleViewResult={handleViewResult}
          onClickData={["IdEpruvetka", "TipRezultat"]}
          handlePageChange={handlePageChange}
          handleResultsPerPageChange={handleResultsPerPageChange}
          text={dataDoctorResultsGrouped}
          buttonText="Виж резултат"
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterEGN={filterEGN}
          filterName={filterName}
          noResultsFound={noResultsFound}
          handleResults={handleResults}
        />
      ) : (
        <Table
          results={examinationData}
          resultCell={[
            "DateRefferal",
            "Paket",
            "IdentifierPac",
            "GivenPacName",
            "MiddlePacName",
            "FamilyPacName",
          ]}
          currentPage={currentPage}
          resultsPerPage={resultsPerPage}
          handleViewResult={handleViewResult}
          onClickData={["IdEpruvetka", "TipRezultat"]}
          handlePageChange={handlePageChange}
          handleResultsPerPageChange={handleResultsPerPageChange}
          text={dataDoctorResults}
          buttonText="Виж резултат"
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterEGN={filterEGN}
          filterName={filterName}
          noResultsFound={noResultsFound}
          setOpenModal2={setOpenModal2}
          setPatientInfo={setPatientInfo}
          setResultsData={setResultsData}
          handleResults={handleResults}
          handleResultsPacs={handleResultsPacs}
        />
      )}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 25000,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            bgcolor: "background.paper",
            borderRadius: 1,
            p: 2,
            boxShadow: 24,
          }}
        >
          <AppHeader />
          {base64Data && (
            <PdfViewer
              base64Data={base64Data}
              fileName={`${examinationData[0].DateRefferal}_${examinationData[0].Paket}_${examinationData[0].GivenPacName}_${examinationData[0].MiddlePacName}_${examinationData[0].FamilyPacName}`}
              handleCloseModal={handleCloseModal}
            />
          )}
        </Box>
      </Modal>
      <Modal
        open={openModal2}
        onClose={handleCloseModal2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 25000,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: 24,
          }}
        >
          <AppHeader />
          <Fragment>
            {patientInfo && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: !isMobile ? "90%" : "100%",
                  flexDirection: "row",
                  marginLeft: isMobile ? "0px" : "20px",
                }}
              >
                <TextContentInfo
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    marginLeft: "0 !important",
                    "& .MuiBox-root": {
                      marginLeft: "0 !important",
                    },
                    "& .MuiTypography-root": {
                      marginLeft: "0",
                    },
                    "& .css-kg3fcp": { width: "80%" },
                  }}
                  text={
                    !isMobile ? (
                      <span
                        style={{
                          fontSize: "25px",
                        }}
                      >
                        Справка резултати
                        <span
                          style={{
                            fontSize: "20px",
                            color: "#333",
                            marginLeft: "25px",
                          }}
                        >
                          {patientInfo.GivenPacName}
                        </span>
                        <span
                          style={{
                            marginLeft: "5px",
                            fontSize: "20px",
                            color: "#333",
                          }}
                        >
                          {patientInfo.MiddlePacName}
                        </span>
                        <span
                          style={{
                            marginLeft: "5px",
                            fontSize: "20px",
                            color: "#333",
                          }}
                        >
                          {patientInfo.FamilyPacName}
                        </span>
                        <span
                          style={{
                            fontSize: "18px",
                            fontWeight: "normal",
                            color: "#333",
                            marginLeft: "30px",
                          }}
                        >
                          {role !== "patient" && "ЕГН:"}{" "}
                          {patientInfo.IdentifierPac}
                        </span>
                      </span>
                    ) : (
                      <Box
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        <Box>
                          <span
                            style={{
                              // marginLeft: "10px",
                              fontSize: "12px",
                              // fontWeight: "bold",
                              color: "#333",
                              // marginLeft: "0 !important",
                            }}
                          >
                            {patientInfo.GivenPacName}
                          </span>
                          <span
                            style={{
                              marginLeft: "5px",
                              fontSize: "12px",
                              // fontWeight: "bold",
                              color: "#333",
                            }}
                          >
                            {patientInfo.MiddlePacName}
                          </span>
                          <span
                            style={{
                              marginLeft: "5px",
                              fontSize: "12px",
                              // fontWeight: "bold",
                              color: "#333",
                            }}
                          >
                            {patientInfo.FamilyPacName}
                          </span>
                        </Box>
                        <Box>
                          <span
                            style={{
                              // marginLeft: "15px",
                              fontSize: "12px",
                              fontWeight: "normal",
                              color: "#333",
                              marginLeft: 0,
                            }}
                          >
                            ЕГН: {patientInfo.IdentifierPac}
                          </span>
                        </Box>
                      </Box>
                    )
                  }
                />

                <Button
                  onClick={handleCloseModal2}
                  sx={{
                    display: "inline-block",
                    marginLeft: "auto",
                    color: config.appBarColor,
                    // padding: "5px",
                  }}
                >
                  X
                </Button>
              </div>
            )}
            {resultsData && resultsData.length > 0 && (
              <TableResults
                resultsData={resultsData}
                resultCell={["TechGroupName", "Result"]}
                currentPage={currentPage}
                resultsPerPage={resultsPerPage}
                handlePageChange={handlePageChange}
                handleResultsPerPageChange={handleResultsPerPageChange}
                text={dataResultsDetailed}
                noResultsFound={noResultsFound}
                setOpenModal2={setOpenModal2}
                setPatientInfo={setPatientInfo}
                setResultsData={setResultsData}
              />
            )}
          </Fragment>
        </Box>
      </Modal>
      <Modal
        open={openModal3}
        onClose={handleCloseModal3}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 25000,
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            bgcolor: "background.paper",
            borderRadius: 1,
            p: 2,
            boxShadow: 24,
          }}
        >
          <AppHeader />
          {dicomData && dicomData.length > 0 ? (
            <DicomViewer
              base64Images={dicomData}
              handleCloseModal3={handleCloseModal3}
            />
          ) : (
            <Typography>No DICOM images available</Typography>
          )}
        </Box>
      </Modal>
    </Fragment>
  );
}
